import { g as l } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const h = {
  name: "DtIconPrintFax",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], m = ["id"];
function p(e, t, n, _, v, i) {
  return d(), o("svg", {
    "aria-label": n.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--print-fax"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Print Fax",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M2.5 1A.5.5 0 0 1 3 .5h6a.5.5 0 0 1 .5.5v3h.5a1.5 1.5 0 0 1 1.5 1.5V8A1.5 1.5 0 0 1 10 9.5h-.5V11a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V9.5H2A1.5 1.5 0 0 1 .5 8V5.5A1.5 1.5 0 0 1 2 4h.5V1ZM2 5a.5.5 0 0 0-.5.5V8a.5.5 0 0 0 .5.5h.5V7a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1.5h.5a.5.5 0 0 0 .5-.5V5.5A.5.5 0 0 0 10 5H2Zm6.5-1h-5V1.5h5V4Zm0 3.5h-5v3h5v-3Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, c);
}
const q = /* @__PURE__ */ u(h, [["render", p]]);
export {
  q as default
};
//# sourceMappingURL=print-fax.js.map
